import { render, staticRenderFns } from "./CompanyContent.vue?vue&type=template&id=bbe4e8ee&scoped=true"
import script from "./CompanyContent.vue?vue&type=script&lang=js"
export * from "./CompanyContent.vue?vue&type=script&lang=js"
import style0 from "./CompanyContent.vue?vue&type=style&index=0&id=bbe4e8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe4e8ee",
  null
  
)

export default component.exports